<template>
  <div class="mx-auto my-4">
    <ValidationObserver v-slot="{ invalid, validate, errors }">
      <form name="requestForm" @submit.prevent="validate().then(() => onSubmit(invalid))">
        <div class="container">
          <!-- <SelectRequiredData
            :enableSchoolYearSelect="enableSchoolYearSelection"
            :schoolYearOptions="schoolYearSelectionOptions"

            :districtOptions="studentDistrictSelectionOptions"
            :enablePartitionSelect="true"
            :enableDistrictSelect="true"
            :enableVendorSelect="true"
            :enableBuildingSelect="true"
            :includePartitionSelect="true"
            :includeDistrictSelect="true"
            :includeVendorSelect="true"
            :includeBuildingSelect="true">
          </SelectRequiredData> -->
          <school-year
            class="w-1/3 pe-5"
            id="schoolYear"
            v-model="formValues.schoolYear"
            :disableDefaultValueUpdates="defaultValueComponentUpdatedMap['schoolYear']"
            :defaultValue="defaultSchoolYear"
            @defaultValueUsed="defaultValueUsed('schoolYear')"
            :enableSchoolYearSelection="enableSchoolYearSelection"
            :options="schoolYearSelectionOptions"
          />
          <district-selection
            class="w-full pe-5"
            :hidden="!showDistrictSelection()"
            id="districtSelection"
            ref="districtSelection"
            v-model="formValues.districtSelection"
            :disableDefaultValueUpdates="defaultValueComponentUpdatedMap['districtSelection']"
            :enableDistrictSelection="enableDistrictSelection"
            :districtSelectionType="districtSelectionType"
            :defaultValue="defaultDistrictSelection"
            @defaultValueUsed="defaultValueUsed('districtSelection')"
            :studentDistrictOptions="studentDistrictSelectionOptions"
          />
        </div>
        <div class="container">
          <student-info
            class="w-full"
            id="studentInfo"
            :disableDefaultValueUpdates="defaultValueComponentUpdatedMap['studentInfo']"
            :defaultValue="defaultStudentInfo"
            @defaultValueUsed="defaultValueUsed('studentInfo')"
            :schoolYear="formValues.schoolYear"
            :districtCode="formValues.districtSelection?.studentDistrict"
            @programSelected="onProgramChange"
            @gradeSelected="onGradeChangeAndCheckStartDate"
            @editSuggestedStudent="onEditSuggestedStudent"
            :key="studentInfoComponentKey"
            v-model="formValues.studentInfo"
          />
        </div>
        <div class="container">
          <StudentAddress
            id="Student"
            label="Student Address"
            :disableDefaultValueUpdates="defaultValueComponentUpdatedMap['studentAddress']"
            :defaultValue="defaultStudentHome"
            @defaultValueUsed="defaultValueUsed('studentAddress')"
            v-model="formValues.studentHome"
            @input="formValues.reviewed = false"
          />
        </div>
        <div class="container">
          <contact-info
            :disableDefaultValueUpdates="defaultValueComponentUpdatedMap['contactInfo']"
            :defaultValue="defaultContactInfo"
            @defaultValueUsed="defaultValueUsed('contactInfo')"
            v-model="formValues.contactInfo"
          />
        </div>
        <div class="container">
          <trans-details
            :startDateSchoolYearWarning="startDateWarningMessage"
            id="transDetails"
            ref="transDetails"
            :attemptedSubmit="attemptedSubmit"
            :disableDefaultValueUpdates="defaultValueComponentUpdatedMap['transDetails']"
            :defaultValue="defaultTransDetails"
            @defaultValueUsed="defaultValueUsed('transDetails')"
            :selectedProgram="selectedProgram"
            :selectedGrade="selectedGrade"
            :studentHomeAddress="formValues.studentHome"
            :selectedSchoolYear="formValues.schoolYear"
            @boosterSeatSelected="onBoosterSeatChange"
            @setReviewed="onSetReviewed"
            v-model="formValues.transDetails"
            @input="onTransDetailsInput"
          />
        </div>
        <div class="container">
          <div class="flex flex-col text-left mt-3 mb-3">
            <label>
              <input
                class="mr-2 pr-2 mb-2.5"
                v-model="formValues.isSibling"
                type="checkbox"
              />
              Check here if you want to submit and create a new student at the same address (ex. sibling)
            </label>
          </div>
          <div class="flex flex-row">
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              name="error-text"
              v-if="displayFormHasErrors(errors) || (!formValues.transDetails?.inboundDays?.length && !formValues.transDetails?.outboundDays?.length)">
              There are errors in fields above.
            </span>
          </div>
          <div class="grid grid-cols-2 border-t-2 mt-2 pt-2">
            <label class="pt-2">
              <ValidationProvider :rules="`required|isChecked`" name="review check" v-slot="{ errors }">
                <input
                  class="mr-2 pr-2 mb-2.5"
                  v-model="formValues.reviewed"
                  type="checkbox"
                  @click="reviewClicked()"
                />
                Check here if you have reviewed all the information provided above:
                <span
                  class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  name="error-text">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </label>
            <SubmitButton
              class="rounded-md h-10 !shadow m-1"
              type="submit"
              :color="'blue'"
              :size="'md'"
              :disabled="!formValues.reviewed"
              :submitting="submitting">
              Submit Form
            </SubmitButton>
          </div>
        </div>
      </form>
      <AddressReview
        ref="address-review"
        :hereApiKey="hereApiKey"
        @reviewChange="onSetReviewed"
        @goBackAndEdit="onGoBackAndEdit"
        @setAddress="onSetAddress"
      />
      <Modal
        size="sm"
        anchor="center"
        ref="require-booster-seat-warning-modal"
        :onSuccess="boosterSeatWarningConfirm"
      >
        <template #title>Warning: Booster Seat</template>
        <template #content>
          <div>
            {{ variations.requireBoosterSeat.parameters.warningMessage }}
          </div>
        </template>
        <template #footer="slotProps">
          <button
            type="button"
            class="rounded-md font-medium text-red-900 bg-red-200 px-3 py-2 hover:bg-red-300 transition-colors shadow-sm"
            @click="() => slotProps.closeModal(true)"
          >
            Confirm
          </button>
        </template>
      </Modal>
      <div v-if="displayEndpoint">
        <p>Endpoint Data: {{ formValues }}</p>
        <p>Default Data: {{ defaultValues }}</p>
      </div>
      <Modal size="sm" anchor="center" ref="start-date-warning-modal"
        :onSuccess="continueAfterStartDateWarning">
        <template #title>
          Confirm Start Date
        </template>

        <template #content>
          <div>
            <p v-if="startDateWarningReason === 'after_last_day'">
              Our records show this start date is after the last day of the selected school year.
            </p>

            <p v-else-if="startDateWarningReason === 'before_first_day'">
              Our records show this start date is before the first day of the selected school year.
            </p>

            <p v-else>
              Our records show this start date looks like it may be outside the selected school year.
            </p>

            <p><strong>Selected school year:</strong> {{ formatSchoolYearLabel(startDateWarningSchoolYear) }}</p>
            <p><strong>Start date:</strong> {{ formatDate(startDateWarningDate) }}</p>
            <p v-if="startDateWarningFirstDay"><strong>First day:</strong> {{ formatDate(startDateWarningFirstDay) }}</p>
            <p v-if="startDateWarningLastDay"><strong>Last day:</strong> {{ formatDate(startDateWarningLastDay) }}</p>
            <p>
              Please confirm before submitting.
            </p>
          </div>
        </template>

        <template #footer="slotProps">
          <button type="button" class="rounded-md px-3 py-2 bg-gray-200 hover:bg-gray-300"
            @click="() => reviewStartDateWarning(slotProps.closeModal)">
            Review
          </button>

          <button v-if="startDateWarningCanContinue" type="button"
            class="rounded-md font-medium text-red-900 bg-red-200 px-3 py-2 hover:bg-red-300 transition-colors shadow-sm ml-2"
            @click="() => slotProps.closeModal(true)">
            Continue
          </button>
        </template>
      </Modal>
    </ValidationObserver>
  </div>
</template>

<script>
import SchoolYear from '../components/SchoolYear.vue'
import DistrictSelection from '../components/DistrictSelection.vue'
import ContactInfo from '../components/ContactInfo.vue'
import StudentAddress from '../components/StudentAddress.vue'
import StudentInfo from '../components/StudentInfo.vue'
import TransDetails from '../components/TransDetails.vue'
import Modal from '../components/Modal.vue'
import AddressReview from '../components/AddressReview.vue'
import SubmitButton from '../components/SubmitButton.vue'

import cloneDeep from 'clone-deep'
import fastDeepEquals from 'fast-deep-equal'
import user from '../services/user/user.js'
import view from '../services/user/view.js'
import events from '../services/events.js'
import notifications from '../services/notifications.js'

import requestFormService from '../services/formSubmission/requestForm.js'

import DROPDOWN_LISTS from '../components/DropdownLists.json'
import { isEmpty, isObject, reduce, every } from 'lodash'

const ALL_COMPONENTS = [
  'schoolYear',
  'districtSelection',
  'studentInfo',
  'studentAddress',
  'contactInfo',
  'transDetails',
]

function createComponentsUpdatedMap(newValue = false) {
  return reduce(
    ALL_COMPONENTS,
    (accum, componentKey) => {
      accum[componentKey] = newValue
      return accum
    },
    {}
  )
}

export default {
  components: {
    SchoolYear,
    DistrictSelection,
    StudentAddress,
    ContactInfo,
    StudentInfo,
    TransDetails,
    Modal,
    AddressReview,
    SubmitButton,
  },
  props: {
    defaultValues: {
      type: Object,
      default: undefined,
    },
    enableSchoolYearSelection: Boolean,
    allowDistrictSelection: Boolean,
    submissionResponse: undefined,
    schoolYearSelectionOptions: {
      type: Array,
      default: undefined,
    },
    studentDistrictSelectionOptions: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      displayEndpoint: process.env.NODE_ENV !== 'production',
      defaultValueComponentUpdatedMap: createComponentsUpdatedMap(),

      pendingRequestFormValues: undefined,
      pendingIsSibling: false,
      startDateWarningSchoolYear: '',
      startDateWarningDate: '',
      startDateWarningFirstDay: '',
      startDateWarningLastDay: '',
      startDateWarningReason: '',
      startDateWarningResponse: undefined,
      startDateWarningModalShownForKey: '',
      startDateWarningCanContinue: false,
      startDateWarningCheckTimeout: undefined,
      attemptedSubmit: false,
      schoolYearOptions: DROPDOWN_LISTS.schoolYears,
      diffPickupTimes: false,
      diffDropoffTimes: false,
      formValues: {},

      user: undefined,
      view: undefined,

      partitions: [],

      hereApiKey: requestFormService.hereApiKey(),
      districtDataLoaded: false,

      userDistricts: undefined,
      districtSelectionType: '',
      //userCanStudentReleaseSelectNotSpecified: false,
      currentAddress: '',
      currentAddressType: '',
      recommendedAddress: {},
      weekdays: DROPDOWN_LISTS.weekdays,
      providedAddresses: [],
      selectedProgram: undefined,
      selectedGrade: undefined,
      studentInfoComponentKey: 0,
      //componentKey: 0,
      submissionPromise: undefined,
      submitting: false,
      variations: {
        requireBoosterSeat: {
          enabled: false,
          parameters: {},
          variables: {}
        }
      },
    }
  },
  eventCallbackIds: {},
  methods: {
    formatTime(initTime) {
      var HH = initTime.substring(0, 2)
      var MM = Number(initTime.substring(3, 5))
      return HH + ':' + MM
    },
    checkDifferentTimes() {
      if (this.defaultValues?.scheduleRequest?.scheduleRequestWeekdays) {
        for (const weekday of this.defaultValues.scheduleRequest.scheduleRequestWeekdays) {
          if (weekday.arrivalTime !== this.defaultValues?.scheduleRequest.arrivalTime ||
              weekday.programStartTime !== this.defaultValues?.scheduleRequest.programStartTime) {
            this.formValues.diffPickupTimes = true
          }
          if (weekday.programEndTime !== this.defaultValues?.scheduleRequest.programEndTime ||
              weekday.departureTime !== this.defaultValues?.scheduleRequest.departureTime) {
            this.formValues.diffDropoffTimes = true
          }
        }
      }
    },
    checkDifferentAddresses() {
      // Checking for weekdays length of 1 may be necessary for older submissions.
      if (this.defaultValues?.scheduleRequest?.scheduleRequestWeekdays &&
        this.defaultValues.scheduleRequest.scheduleRequestWeekdays.length > 1) {
        for (const weekday of this.defaultValues.scheduleRequest.scheduleRequestWeekdays) {
          if (fastDeepEquals(weekday.pickupAddress, this.defaultValues?.scheduleRequest.address) == false &&
              fastDeepEquals(weekday.pickupAddress, this.defaultValues?.scheduleRequest.pickupAddress) == false) {
            this.formValues.diffPickupTimes = true
          }
          if (fastDeepEquals(weekday.dropoffAddress, this.defaultValues?.scheduleRequest.address) == false &&
              fastDeepEquals(weekday.dropoffAddress, this.defaultValues?.scheduleRequest.dropoffAddress) == false) {
            this.formValues.diffDropoffTimes = true
          }
        }
      }
    },
    setDayString(day) {
      return DROPDOWN_LISTS.weekdays[day]
    },
    setDistrict(val) {
      if(val) {
        this.formValues.districtSelection = {
          'studentDistrict': val.studentDistrict,
          'requestingDistrict': val.requestingDistrict,
          'residentDistrict': val.residentDistrict
        }
      }
      else {
        this.formValues.districtSelection = {
          studentDistrict: this.defaultValues.district,
          requestingDistrict: this.defaultValues.infoRequestingDistrict,
          residentDistrict: this.defaultValues.infoResidentDistrict
        }
      }
    },
    setDisableDefaultValueUpdates(newValue) {
      this.defaultValueComponentUpdatedMap = createComponentsUpdatedMap(newValue)
    },
    defaultValueUsed(componentKey) {
      this.defaultValueComponentUpdatedMap[componentKey] = true
    },
    resetComponentsUpdated() {
      this.defaultValueComponentUpdatedMap = createComponentsUpdatedMap()
      this.$refs.transDetails.resetComponentsUpdated()
    },
    async updateUser() {
      this.user = await user.get()
      this.view = await view.get()
      this.districtDataLoaded = false
      await requestFormService.getDistrictFromServer()
      this.districtDataLoaded = true

      this.partitions = this.view.getPartition()

      this.userDistricts = await requestFormService.getAllDistrictForView(this.view)

      //this.user.userData.capabilities = ["changeRole", "selectPartition", "optionStudentReleaseNotSpecify", "accessStudentList", 'selectRequestingDistrict'] // for testing not being able to set districts

      if (this.user.can('select_district')) {
        this.districtSelectionType = 'all'
      }
      else if (this.user.can('select_requesting_district')) {
        this.districtSelectionType = 'single'
      }

      this.userCanStudentReleaseSelectNotSpecified = this.user.can('optionStudentReleaseNotSpecify')
    },
    onProgramChange(message) {
      this.selectedProgram = message
    },
    onGradeChange(message) {
      this.selectedGrade = message

      if (this.variations.requireBoosterSeat.enabled) {
        this.runBoosterSeat('gradeChange', message)
      }
    },
    onBoosterSeatChange(message) {
      if (this.variations.requireBoosterSeat.enabled) {
        this.runBoosterSeat('boosterSeatChange', message)
      }
    },
    onEditSuggestedStudent(dbId) {
      this.$emit('editSuggestedStudent', dbId)
    },
    onSetReviewed(reviewed) {
      this.formValues.reviewed = reviewed;
    },
    onGoBackAndEdit(addressType) {
      this.scroll(addressType)
    },
    onSetAddress(addressObj, newAddress) {
      console.log(addressObj, newAddress)
    },
    checkStudentDistrictAgainstUserDistrict() {
      console.log(this.userDistricts)
      if (this.user.can('select_district')) {
        if (!isEmpty(this.userDistricts)) {
          return this.userDistricts.includes(this.formValues.districtSelection?.studentDistrict)
        }
        else {
          return true
        }
      }
      else {
        let userConfigDistrictCode = this.user.getConfig('district_code')
        return userConfigDistrictCode === this.formValues.districtSelection?.studentDistrict
      }
    },
    continueAfterStartDateWarning() {
      return this.submitRequestForm(
        this.pendingRequestFormValues,
        this.pendingIsSibling
      )
    },
    submitRequestForm(clonedFormValues, isSibling) {
      this.submissionPromise = new Promise((resolve, reject) => {
        this.$emit(
          'submit',
          resolve,
          reject,
          clonedFormValues,
          isSibling
        )
      })
        .then(() => {
          this.submitting = false
          this.submissionPromise = undefined
          this.pendingRequestFormValues = undefined
          this.pendingIsSibling = false
        })
        .catch(() => {
          this.submitting = false
          this.submissionPromise = undefined
        })

      return this.submissionPromise
    },
    async checkStartDateWarningForCurrentForm() {
      const startDate = this.formValues?.transDetails?.startDate
      const startYear = startDate ? Number(startDate.slice(0, 4)) : undefined

      if (
        !startDate ||
        !/^\d{4}-\d{2}-\d{2}$/.test(startDate) ||
        startYear < 2000 ||
        !this.formValues?.transDetails?.school?.id ||
        !this.formValues?.schoolYear ||
        !this.formValues?.studentInfo?.grade
      ) {
        this.startDateWarningResponse = undefined
        this.startDateWarningModalShownForKey = ''
        return
      }

      const clonedFormValues = cloneDeep(this.formValues)

      if (clonedFormValues.schoolYear?.schoolYearSelect) {
        clonedFormValues.schoolYear = clonedFormValues.schoolYear.schoolYearSelect
      }

      const warningResponse = await requestFormService.checkStartDateWarning(clonedFormValues)
      this.startDateWarningResponse = warningResponse.data
      if (!warningResponse.data?.should_warn) {
        this.startDateWarningModalShownForKey = ''
        return
      }
      const warningKey = [
        clonedFormValues.schoolYear,
        clonedFormValues.transDetails.startDate,
        clonedFormValues.transDetails.school?.id,
        clonedFormValues.studentInfo.grade,
      ].join('|')

      if (this.startDateWarningModalShownForKey !== warningKey) {
        this.startDateWarningModalShownForKey = warningKey

        this.startDateWarningSchoolYear = clonedFormValues.schoolYear
        this.startDateWarningDate = clonedFormValues.transDetails.startDate
        this.startDateWarningFirstDay = warningResponse.data.first_day
        this.startDateWarningLastDay = warningResponse.data.last_day
        this.startDateWarningReason = warningResponse.data.reason
        this.startDateWarningCanContinue = false

        this.$refs['start-date-warning-modal'].openModal()
      }
    },
    onTransDetailsInput(value) {
      this.formValues.transDetails = value

      this.$nextTick(() => {
        this.queueStartDateWarningCheck()
      })
    },
    onGradeChangeAndCheckStartDate(value) {
      this.onGradeChange(value)

      this.$nextTick(() => {
        this.queueStartDateWarningCheck()
      })
    },
    queueStartDateWarningCheck() {
      clearTimeout(this.startDateWarningCheckTimeout)

      this.startDateWarningCheckTimeout = setTimeout(() => {
        this.checkStartDateWarningForCurrentForm()
      }, 500)
    },
    reviewStartDateWarning(closeModal) {
      closeModal(false)

      this.$nextTick(() => {
        this.$refs.transDetailsSection?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })

        this.highlightStartDateWarning = true

        setTimeout(() => {
          this.highlightStartDateWarning = false
        }, 3000)
      })
    },
    formatDate(data) {
      if (data) {
        return new Date(data).toLocaleString('en-US', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          timeZone: 'UTC',
        })
      }

      return ''
    },
    formatSchoolYearLabel(schoolYear) {
      return this.schoolYearOptions?.[schoolYear] || schoolYear
    },
    async onSubmit(formInvalid) {
      this.attemptedSubmit = true;

      let hasError = this.scrollToFirstError();

      if (formInvalid || hasError) {
        return false;
      }
      this.submitting = true

      if (!this.formValues.transDetails?.inboundDays?.length && !this.formValues.transDetails?.outboundDays?.length) {
        return false;
      }

      if (!this.formValues.transDetails?.specialNeeds?.needsList?.includes("infoSolo")) {
        this.formValues.transDetails.enclosedVehicle = false;
      }

      if (!this.formValues.transDetails?.specialNeeds?.needsList?.includes("infoAide")) {
        this.formValues.transDetails.aideOnetoOne = false;
      }

      // since gender doesn't allow for blank strings, convert any to null
      if(this.formValues.studentInfo?.gender == "") {
        this.formValues.studentInfo.gender = null;
      }

      if (this.submissionPromise !== undefined) {
        return
      }

      console.log(JSON.stringify(this.formValues))

      if (this.user?.can('select_district') && !this.checkStudentDistrictAgainstUserDistrict()) {
        notifications.pushError("Student district and user's selected district do not match.")
        return
      }
      let clonedFormValues = cloneDeep(this.formValues)
      for (const [key, value] of Object.entries(clonedFormValues)) {
        if (
          Array.isArray(value) &&
          value.length === 1 &&
          key != 'contactInfo'
        ) {
          clonedFormValues[key] = value[0]
        }
        if (['isSibling', 'reviewed'].includes(key)) {
          delete clonedFormValues[key]
        }
      }
      if (clonedFormValues.transDetails.schoolCode) {
        delete clonedFormValues.transDetails.schoolAddress
      }
      if (clonedFormValues.studentInfo.dateOfBirth === '') {
        clonedFormValues.studentInfo.dateOfBirth = null
      }
      if (clonedFormValues.transDetails.schoolDistrictId === '') {
        clonedFormValues.transDetails.schoolDistrictId = null
      }
      if (clonedFormValues.transDetails.aideOnetoOne) {
        delete clonedFormValues.transDetails.aideOnetoOne
      }
      if (clonedFormValues.transDetails.studentRelease === 'n/a') {
        clonedFormValues.transDetails.studentRelease = null
      }
      if (clonedFormValues.transDetails.startTime === '') {
        clonedFormValues.transDetails.startTime = null
      }
      if (clonedFormValues.transDetails.arrivalTime === '') {
        clonedFormValues.transDetails.arrivalTime = null
      }
      if (clonedFormValues.transDetails.schoolEndTime === '') {
        clonedFormValues.transDetails.schoolEndTime = null
      }
      if (clonedFormValues.transDetails.departureTime === '') {
        clonedFormValues.transDetails.departureTime = null
      }

      if (clonedFormValues.transDetails.inboundDayDifferent) {
        for (const dayDiff of clonedFormValues.transDetails.inboundDayDifferent) {
          if (dayDiff.programTime === '') {
            dayDiff.programTime = null
          }
          if (dayDiff.transportTime === '') {
            dayDiff.transportTime = null
          }
        }

        clonedFormValues.transDetails.inboundDayDifferent =
          clonedFormValues.transDetails.inboundDayDifferent.filter(
            el => clonedFormValues.transDetails.inboundDays.includes(el.day)
          )
      }
      if (clonedFormValues.transDetails.outboundDayDifferent) {
        for (const dayDiff of clonedFormValues.transDetails.outboundDayDifferent) {
          if (dayDiff.programTime === '') {
            dayDiff.programTime = null
          }
          if (dayDiff.transportTime === '') {
            dayDiff.transportTime = null
          }
        }

        clonedFormValues.transDetails.outboundDayDifferent =
          clonedFormValues.transDetails.outboundDayDifferent.filter(
            el => clonedFormValues.transDetails.outboundDays.includes(el.day)
          )
      }

      if (clonedFormValues.studentHome) {
        requestFormService.clearEmptyLatLong(clonedFormValues.studentHome)
      }
      if (clonedFormValues.schoolAddress) {
        requestFormService.clearEmptyLatLong(clonedFormValues.schoolAddress)
      }
      if (clonedFormValues.school?.address) {
        requestFormService.clearEmptyLatLong(clonedFormValues.school?.address)
      }
      for (const dayData of clonedFormValues.transDetails.inboundDayDifferent) {
        requestFormService.clearEmptyLatLong(dayData.address)
      }
      for (const dayData of clonedFormValues.transDetails.outboundDayDifferent) {
        requestFormService.clearEmptyLatLong(dayData.address)
      }

      for (const [key, value] of Object.entries(clonedFormValues.transDetails)) {
        if (
          Array.isArray(value) &&
          value.length === 1 &&
          !['specialNeeds', 'inboundDays', 'outboundDays', 'inboundDayDifferent', 'outboundDayDifferent'].includes(key)
        ) {
          clonedFormValues.transDetails[key] = value[0]
        }
      }
      if (clonedFormValues.schoolYear.schoolYearSelect) {
        clonedFormValues.schoolYear = clonedFormValues.schoolYear.schoolYearSelect
      }
      const warningResponse = await requestFormService.checkStartDateWarning(clonedFormValues)

      if (warningResponse.data?.should_warn) {
        this.startDateWarningSchoolYear = clonedFormValues.schoolYear
        this.startDateWarningDate = clonedFormValues.transDetails.startDate
        this.startDateWarningFirstDay = warningResponse.data.first_day
        this.startDateWarningLastDay = warningResponse.data.last_day
        this.startDateWarningReason = warningResponse.data.reason

        this.pendingRequestFormValues = clonedFormValues
        this.pendingIsSibling = this.formValues.isSibling
        this.startDateWarningCanContinue = true
        this.$refs['start-date-warning-modal'].openModal()
        this.submitting = false
        return false
      }

      if ((this.formValues.transDetails.inboundDays.length < 1) && (this.formValues.transDetails.outboundDays.length < 1)) {
        this.scroll('transDetails')
        this.$refs['transDetails'].blurDays()
        return false
      }
      return this.submitRequestForm(clonedFormValues, this.formValues.isSibling)
    },
    scroll(id) {
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToFirstError() {
      const elems = document.getElementsByName('error-text');
      let hasError = false

      for (let el of Array.from(elems)) {
        if (el.innerText && el.innerText.trim()) {
          hasError = true
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          })
          break
        }
      }

      return hasError
    },
    showDistrictSelection() {
      if (this.user === undefined) {
        return false
      }

      return this.user.can('select_district') || this.user.can('select_requesting_district')
    },
    invalidMessage() {
      return `Oops! There are some errors above. Please make sure all required fields are filled out.`
    },
    reviewClicked() {
      if (!this.formValues.reviewed) {
        // runs before formValues.reviewed toggles, so it will still be false at this point when checking the checkbox
        let providedAddresses = []
        let addresses = {
          'Drop-off': this.formValues.transDetails.newDropoffAddress,
          'Pick-up': this.formValues.transDetails.newPickupAddress,
          'Student': this.formValues.studentHome
        }

        if (this.formValues.transDetails.isNewSchool) {
          addresses['School'] = this.formValues.transDetails.school?.address
        }

        if (Array.isArray(this.formValues.transDetails.outboundDayDifferent)) {
          for (const outboundDayDifferent of this.formValues.transDetails.outboundDayDifferent) {
            addresses[`Outbound Day-${outboundDayDifferent.day}`] = outboundDayDifferent.address
          }
        }

        if (Array.isArray(this.formValues.transDetails.inboundDayDifferent)) {
          for (const inboundDayDifferent of this.formValues.transDetails.inboundDayDifferent) {
            addresses[`Inbound Day-${inboundDayDifferent.day}`] = inboundDayDifferent.address
          }
        }

        for (const [key, address] of Object.entries(addresses)) {
          if (address) {
            providedAddresses.push({ key, address })
          }
        }

        this.$refs['address-review'].checkAddresses(providedAddresses)
      }
    },
    setLeadTime(leadTime){
      this.$refs.transDetails.setLeadTime(leadTime)
    },
    clearStudentInfo() {
      if (this.formValues.studentInfo) {
        delete this.formValues['studentInfo']
        this.formValues.reviewed = false
        this.formValues.isSibling = false
        this.studentInfoComponentKey += 1
      }
    },
    updateBuildingSelection() {
      this.$refs.transDetails.updateBuildingSelection()
    },
    requireBoosterSeat(enable, gradeMin, gradeMax, warningMessage) {
      this.variations.requireBoosterSeat.parameters = {
        gradeMin,
        gradeMax,
        warningMessage
      }
      this.variations.requireBoosterSeat.variables = {
        gradeSelected: undefined,
        boosterSeatSelected: false
      }
    },
    runBoosterSeat(action, newValue) {
      if (action == 'gradeChange') {
        let gradeMin = this.variations.requireBoosterSeat.parameters.gradeMin
        let gradeMax = this.variations.requireBoosterSeat.parameters.gradeMax

        if (gradeMin <= this.selectedGrade && this.selectedGrade <= gradeMax) {
          this.$refs['transDetails'].setBoosterSeatOverride(true)
          if (
            !this.variations.requireBoosterSeat.variables.boosterSeatSelected
          ) {
            this.$refs['transDetails'].setBoosterSeat(true, true)
            this.variations.requireBoosterSeat.variables.boosterSeatSelected = true
          }
        } else {
          this.$refs['transDetails'].setBoosterSeatOverride(false)
        }
        this.variations.requireBoosterSeat.variables.gradeSelected = newValue
      }
      else if (action == 'boosterSeatChange') {
        let gradeMin = this.variations.requireBoosterSeat.parameters.gradeMin
        let gradeMax = this.variations.requireBoosterSeat.parameters.gradeMax

        if (gradeMin <= this.selectedGrade && this.selectedGrade <= gradeMax) {
          if (
            this.variations.requireBoosterSeat.variables.boosterSeatSelected &&
            !newValue
          ) {
            this.$refs['transDetails'].setBoosterSeat(true, true)
            this.$refs['require-booster-seat-warning-modal'].openModal()
            this.variations.requireBoosterSeat.variables.boosterSeatSelected = true
          } else {
            this.variations.requireBoosterSeat.variables.boosterSeatSelected = newValue
          }
        } else {
          this.variations.requireBoosterSeat.variables.boosterSeatSelected = newValue
        }
      }
    },
    boosterSeatWarningConfirm() {
      this.$refs['transDetails'].setBoosterSeatPrevValue(false)
      this.$refs['transDetails'].setBoosterSeat(false, true)
      this.variations.requireBoosterSeat.variables.boosterSeatSelected = false
    },
    displayFormHasErrors(errorsMap) {
      return Object.values(errorsMap).flat().length > 0
    }
  },
  created() {
    // this.resetComponentsUpdated()
  },
  async mounted() {
    this.updateUser()
    this.formValues.reviewed = false
    this.resetComponentsUpdated()

    this.$options.eventCallbackIds.viewUpdated = events.register(
      'viewUpdated',
      () => {
        this.updateUser()
        this.$refs.transDetails.getAllBuildingsAndSetDefaultTransDetails()
        if (this.districtSelectionType === 'all') {
          this.$refs.districtSelection.getAllDistricts()
        }
      }
    )
  },
  beforeDestroy() {
    events.remove(
      'viewUpdated',
      this.$options.eventCallbackIds.viewUpdated
    )
  },
  watch: {
    submissionResponse(newValue) {
      if (newValue !== undefined) {
        this.submissionPromise.resolve()
      }
    },
    allComponentsUpdated(newValue) {
      if (newValue === true) {
        this.disableDefaultValueUpdates = true
      }
    },
    defaultValues() {
      this.checkDifferentTimes()
      this.checkDifferentAddresses()
    },
    'formValues.districtSelection.studentDistrict': {
      handler: function (newValue) {
        this.$emit('selectedStudentDistrict', newValue)
      },
      deep: true,
    },
      'formValues.schoolYear': {
        deep: true,
        handler() {
          this.queueStartDateWarningCheck()
        },
      },
  },
  computed: {
    enableDistrictSelection() {
      if (this.user === undefined) {
        return false
      }

      return this.user.can('select_district') && this.allowDistrictSelection
    },
    allComponentsUpdated() {
      return every(this.defaultValueComponentUpdatedMap)
    },
    defaultSchoolYear() {
      if (
        this.defaultValues === undefined ||
        this.defaultValues.schoolYear === undefined
      ) {
        return
      }
      return this.defaultValues.schoolYear
    },
    defaultDistrictSelection() {
      if (!this.districtDataLoaded || this.defaultValues === undefined || this.user === undefined) {
        return
      }

      if (this.defaultValues.district) {
        let districtCode = isObject(this.defaultValues.district)
          ? this.defaultValues.district.code
          : this.defaultValues.district
        //this.setDistrict() // re-enable if issues are caused by not resetting district selections when default district data changes
        let districtObj = requestFormService.getDistrictSync(districtCode)
        return {
          studentDistrict: districtObj,
          requestingDistrict: this.defaultValues.infoRequestingDistrict,
          residentDistrict: this.defaultValues.infoResidentDistrict
        }
      }
      return undefined
    },
    defaultStudentInfo() {
      if (
        this.defaultValues?.student === undefined ||
        this.defaultValues?.scheduleRequest.notes === undefined ||
        this.defaultValues?.student.dbId === undefined
      ) {
        return
      }
      let fields = [
        'firstName',
        'middleName',
        'lastName',
        'dateOfBirth',
        'gender',
        'language',
        'grade',
        'studentId',
        'program',
        'marssCode'
      ]
      let ret = {}
      for (const field of fields) {
        ret[field] = this.defaultValues.student[field]
      }
      if (this.defaultValues.scheduleRequest.notes.customProgram) {
        ret['customProgram'] = this.defaultValues.scheduleRequest.notes.customProgram
      }
      ret['dbId'] = this.defaultValues.student.dbId
      return ret
    },
    defaultStudentHome() {
      if (this.defaultValues === undefined) {
        return ''
      }
      return this.defaultValues.address ? this.defaultValues.address : ''
    },
    defaultContactInfo() {
      if (this.defaultValues === undefined) {
        return ''
      }
      return this.defaultValues.contacts ? this.defaultValues.contacts : ''
    },
    defaultTransDetails() {
      let transDetails = {
        inboundDays: [],
        outboundDays: [],
        inboundDayDifferent: [],
        outboundDayDifferent: [],
      }

      if (this.defaultValues?.scheduleRequest === undefined) {
        return transDetails
      }

      let today = new Date()
      if (
        this.defaultValues?.scheduleRequest.requestedStartDate &&
        new Date(this.defaultValues?.scheduleRequest.requestedStartDate) > today
      ) {
        transDetails['startDate'] = this.defaultValues?.scheduleRequest.requestedStartDate
      }

      transDetails['endDate'] = this.defaultValues?.scheduleRequest.requestedEndDate
      transDetails['school'] = this.defaultValues?.scheduleRequest.building
      transDetails['isNewSchool'] = false
      for (const field of ['arrivalTime', 'departureTime', 'studentRelease']) {
        transDetails[field] = this.defaultValues?.scheduleRequest[field]
      }
      transDetails['startTime'] = this.defaultValues?.scheduleRequest.programStartTime
      transDetails['schoolEndTime'] = this.defaultValues?.scheduleRequest.programEndTime

      if (this.defaultValues?.scheduleRequest.pickupAddress) {
        transDetails['newPickupAddress'] = this.defaultValues?.scheduleRequest.pickupAddress
        transDetails['diffPickupAddress'] = true
      }
      if (this.defaultValues?.scheduleRequest.dropoffAddress) {
        transDetails['newDropoffAddress'] = this.defaultValues?.scheduleRequest.dropoffAddress
        transDetails['diffDropoffAddress'] = true
      }

      if (this.defaultValues?.scheduleRequest.medicalNotes) {
        transDetails['medicalInfo'] = this.defaultValues?.scheduleRequest.medicalNotes
      }
      if (this.defaultValues?.scheduleRequest.notes.additional) {
        transDetails['additionalInfo'] = this.defaultValues?.scheduleRequest.notes.additional
      }
      if (this.defaultValues?.scheduleRequest.notes.outbound) {
        transDetails['outboundInfo'] = this.defaultValues?.scheduleRequest.notes.outbound
      }
      if (this.defaultValues?.scheduleRequest.notes.inbound) {
        transDetails['inboundInfo'] = this.defaultValues?.scheduleRequest.notes.inbound
      }

      transDetails.specialNeeds = {needsList: []}
      let needsList = [
        'infoAide',
        'infoWheelchair',
        'infoSolo',
        'infoEnclosedVehicle',
        'infoBoosterSeat',
        'infoSafetyVest',
        'infoSafetyBeltLockingCover',
        'infoCarSeat'
      ]
      if (this.defaultValues?.scheduleRequest?.vestInfo) {
        transDetails.specialNeeds['vestInfo'] = this.defaultValues?.scheduleRequest.vestInfo
      }
      for (const need of needsList) {
        if (this.defaultValues?.scheduleRequest[need]) {
          transDetails.specialNeeds['needsList'].push(need)
          if (need == 'infoAide') {
            transDetails.specialNeeds['aide'] = this.defaultValues?.scheduleRequest.infoAide
            transDetails.specialNeeds['aideOnetoOne'] =
              transDetails.specialNeeds.aide == 'A1:1' ? true : false
          }
        }
      }

      if (this.defaultValues?.scheduleRequest?.scheduleRequestWeekdays) {
        for (const weekday of this.defaultValues.scheduleRequest.scheduleRequestWeekdays) {
          if (weekday.isPickup) {
            transDetails.inboundDays.push(this.weekdays[weekday.weekday])
          }
          if (weekday.isDropoff) {
            transDetails.outboundDays.push(this.weekdays[weekday.weekday])
          }
        }

        for (const weekday of this.defaultValues.scheduleRequest.scheduleRequestWeekdays) {
          if (this.formValues.diffPickupTimes) {
            if (weekday.isPickup) {
              transDetails.inboundDayDifferent.push({
                'day': this.setDayString(weekday.weekday),
                'programTime': weekday.programStartTime,
                'transportTime': weekday.arrivalTime,
                'diffAddress': true,
                'address': weekday.pickupAddress,
              })
            }
          }
          if (this.formValues.diffDropoffTimes) {
            if (weekday.isDropoff) {
              transDetails.outboundDayDifferent.push({
                'day': this.setDayString(weekday.weekday),
                'programTime': weekday.programEndTime,
                'transportTime': weekday.departureTime,
                'diffAddress': true,
                'address': weekday.dropoffAddress,
              })
            }
          }
        }
      }

      transDetails.diffPickupTimes = this.formValues.diffPickupTimes
      transDetails.diffDropoffTimes = this.formValues.diffDropoffTimes
      return transDetails
    },
    startDateWarningMessage() {
      if (this.startDateWarningResponse?.reason === 'after_last_day') {
        return 'Our records show this start date is after the last day of the selected school year.'
      }

      if (this.startDateWarningResponse?.reason === 'before_first_day') {
        return 'Our records show this start date is before the first day of the selected school year.'
      }

      if (this.startDateWarningResponse?.reason === 'far_future') {
        return 'Our records show this start date is in the future.'
      }

      return ''
    },
  }
}

</script>
